import { render } from "./BaseLayout.vue?vue&type=template&id=bd1e85a8"
const script = {}

import exportComponent from "/pro/vue/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__